import { AlertCircle, CheckCircle, XCircle, Info, X } from 'lucide-react';

const variants = {
  success: {
    container: 'bg-income-50 border-income-200 text-income-800',
    icon: CheckCircle,
    iconColor: 'text-income-500'
  },
  error: {
    container: 'bg-expense-50 border-expense-200 text-expense-800',
    icon: XCircle,
    iconColor: 'text-expense-500'
  },
  warning: {
    container: 'bg-amber-50 border-amber-200 text-amber-800',
    icon: AlertCircle,
    iconColor: 'text-amber-500'
  },
  info: {
    container: 'bg-primary-50 border-primary-200 text-primary-800',
    icon: Info,
    iconColor: 'text-primary-500'
  }
};

export default function Alert({ variant = 'info', title, message, onClose, className = '' }) {
  const { container, icon: Icon, iconColor } = variants[variant];

  // Handle multi-line messages (from validation errors)
  const renderMessage = () => {
    if (typeof message === 'string' && message.includes('\n')) {
      return (
        <ul className="text-sm list-disc list-inside space-y-1">
          {message.split('\n').map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      );
    }
    return <p className="text-sm">{message}</p>;
  };

  return (
    <div className={`rounded-lg border p-4 ${container} ${className}`} role="alert">
      <div className="flex gap-3">
        <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${iconColor}`} />
        <div className="flex-1 min-w-0 break-words">
          {title && (
            <h3 className="font-medium mb-1">{title}</h3>
          )}
          {renderMessage()}
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="flex-shrink-0 p-1 -mr-1 -mt-1 rounded hover:bg-black/5 transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
